import PropTypes from 'prop-types' // eslint-disable-line no-unused-vars
import css from '../../css/add-gif.css'

const AddGif = ({ url, label }) => (
    <a className={css.addGif} href={url || '/upload'} data-gif>
        <i className={css.addIcon} />
        <span className={css.addLabel}>{label || 'Add a GIF'}</span>
    </a>
)

AddGif.propTypes = {
    url: PropTypes.string,
    label: PropTypes.string,
}

export default AddGif
